import PageWrapper from '@/components/page-wrapper'
import Banner from './banner'
import FinancingOption from './financing-option'
import AfterSale from './after-sale'

export default function ServiceSupport() {
  return (
    <PageWrapper>
      <Banner />
      <FinancingOption />
      <AfterSale />
    </PageWrapper>
  )
}
